<template>
  <div class="widgets-container">
    <div class="widget">
      <todo-list
        @resize="displayTodoModal = true"
        :projectId="projectId"
        expandLabel="Expand"
      ></todo-list>
    </div>
    <div class="widget">
      <events-list
        :projectId="projectId"
        @expand="showCalendar = true"
        :calendarOpen="showCalendar"
      ></events-list>
    </div>

    <Dialog
      v-model:visible="showCalendar"
      contentClass="calendar-modal"
      :dismissableMask="true"
      :closeOnEscape="false"
      :autoZIndex="false"
      :modal="true"
    >
      <calendar
        :projectId="projectId"
        size="expand"
        @event-removed="removeEventSecondary"
        @event-added="addEventSecondary"
        @event-modified="modifyEventSecondary"
      ></calendar>
    </Dialog>
  </div>
</template>
<script>
import { ref } from "vue";
import TodoList from "../components/TodoList.vue";
import EventsList from "../components/EventsList.vue";
import Calendar from "../components/Calendar.vue";
export default {
  props: {
    projectId: {
      required: true,
      type: String
    }
  },
  components: {
    TodoList,
    EventsList,
    Calendar
  },
  setup() {
    const showCalendar = ref(false);
    const updateCalendar = ref(null);

    function removeEventSecondary(eventId) {
      updateCalendar.value = {
        action: "remove",
        id: eventId
      };
    }

    function addEventSecondary(event) {
      updateCalendar.value = {
        action: "add",
        event: event
      };
    }

    function modifyEventSecondary(event) {
      updateCalendar.value = {
        action: "modify",
        event: event
      };
    }

    return {
      showCalendar,
      removeEventSecondary,
      addEventSecondary,
      modifyEventSecondary
    };
  }
};
</script>
<style scoped>
.widgets-container {
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}
</style>
